import BaseHttpHandler from './utilities/baseHttpHandler';
import CONSTANTS from "./constants";

async function getRegistration() {
    try {
        let instance = await BaseHttpHandler.getInstance();

        const response = await instance.get(
            CONSTANTS.API_CONSTANTS.ENDPOINTS.REGISTRATION,
            {
                cancelToken: BaseHttpHandler.getTimedCancelToken().token,
            }
        );
        
        return response.data;

    } catch (e) {
        console.log(e);
        throw (e);
    }
}

async function setRegistrationStatus(status) {
    try {
        let instance = await BaseHttpHandler.getInstance();
        let data = {};

        const response = await instance.put(
            `${CONSTANTS.API_CONSTANTS.ENDPOINTS.REGISTRATION}/${status}`,
            data,
            {
                cancelToken: BaseHttpHandler.getTimedCancelToken().token,
            }
        );
        return response.data;

    } catch (e) {
        console.log(e);
        throw (e);
    }
}

async function setRegisteredNumber(number) {
    try {
        let instance = await BaseHttpHandler.getInstance();
        let data = {};
        const newNumber = number.replace(/\D/g, "");

        const response = await instance.put(
          `${CONSTANTS.API_CONSTANTS.ENDPOINTS.REGISTRATION_NUMBER}/${newNumber}`,
          data,
          {
            cancelToken: BaseHttpHandler.getTimedCancelToken().token,
          }
        );

        return response.data;

    } catch (e) {
        console.log(e);
        throw (e);
    }
}

export default {
    getRegistration,
    setRegistrationStatus,
    setRegisteredNumber,
};
